import React from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";
import moment from "moment";
import { Task } from "model/task";
import { Lead } from "model/lead";
import { Agent } from "model/agent";
import { User } from "model/user";
import { TaskType } from "type/task-type";
import { agentTasksDev } from "shared/env";
import { FeatherIcon } from "component/shared/feather-icon";
import { RouterLinkWrapper } from "component/shared/router-link-wrapper";
import { urls } from "routes/urls";
import { dateTimeFormatter } from "shared/date-formatter";
import { AgentTag } from "component/shared/agent-tag";

interface Props {
	task: Task;
	lead?: Lead;
	agent?: Agent;
	user: User;
	assigner?: Agent;
	ownsTask: boolean;
	checked: boolean;
	classes: Record<string, string>;
	onToggleCheckbox: () => void;
}

export const TaskCardLeft: React.FC<Props> = ({
	task,
	lead,
	agent,
	user,
	assigner,
	ownsTask,
	checked,
	classes,
	onToggleCheckbox,
}) => {
	const { title, description, type, startOn, endOn } = task;
	const checkedStyle = { textDecoration: checked ? "line-through" : "none" };
	const dateText =
		type === TaskType.APPOINTMENT
			? `Starts ${dateTimeFormatter(startOn)}`
			: `Due ${dateTimeFormatter(endOn)}`;
	const isOverdue = endOn < moment();

	return (
		<div className={classes.leftSection}>
			<Mui.Checkbox
				onChange={onToggleCheckbox}
				checked={checked}
				className={classes.checkbox}
			/>
			<div className={classes.contentSection}>
					<div className={classes.titleRow}>
						<span className={classes.title} style={checkedStyle}>
							{title}
						</span>
						{lead && (
							<>
								<span className={classes.forText} style={checkedStyle}>
									{" "}
									for{" "}
								</span>
								<RouterLinkWrapper
									className={`${classes.leadLink} ${checked ? classes.checkedLink : ''}`}
									to={urls.lead(lead)}
								>
									{lead.label}
								</RouterLinkWrapper>
							</>
						)}
					</div>
					{type && (
						<Mui.Chip
							icon={<type.icon size={16} />}
							label={type.name}
							className={`${classes.typeChip} ${classes.typeChipMobile}`}
						/>
					)}
					{description && (
						<Mui.Typography
							className={`${classes.description} ${checked ? classes.checkedText : ''}`}
						>
							{description}
						</Mui.Typography>
					)}
					<div className={classes.dateRow}>
						{isOverdue ? (
							<Icons.AlertCircle className={classes.dateIconOverdue} size={16} />
						) : (
							<Icons.Calendar className={classes.dateIconNormal} size={16} />
						)}
						<span
							className={`${classes.date} ${
								isOverdue ? classes.dateOverdue : classes.dateNormal
							}`}
						>
							{dateText}
						</span>
					</div>
					{agent && (
						<div className={classes.agentRow}>
							<span className={classes.agentLabel}>Assigned to</span>
							<RouterLinkWrapper
								className={classes.agentName}
								to={urls.agentProfile(agent.id)}
							>
								{agent.label}
							</RouterLinkWrapper>
						</div>
					)}
			</div>
		</div>
	);
};
